import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getInvestmentsData } from 'store/features/investments/actions';
import Button from 'components/library/Button/Button';

import styles from './ConfirmationSuccess.module.css';
import { AppDispatch } from 'store/types';
import * as statuses from 'store/states';

export default function ConfirmationSuccess({
  status,
}: { status: typeof statuses[keyof typeof statuses] }) {
  const { t } = useTranslation();

  const { id } = useParams();
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    if (status === 'IDLE') {
      dispatch(getInvestmentsData(parseInt(id || '0')));
    }
  }, [dispatch, id, status]);

  const getDashboard = () => {
    window.location.assign(`https://${process.env.REACT_APP_DEBUG ? 'dev-' : ''}invest.ayomi.fr/?refresh_token=${window.localStorage.getItem('auth_refresh')}`)
  };
  return (
    <div className={styles.background}>
      <section className={styles.modal} data-cy="confirmation-popup-success">
        <div className={styles.illustration}>
          <span className={`${styles.materialIcons} material-icons`}>check_circle</span>
        </div>
        <p className={styles.title}>
          {t('coordonnate.loi.success.title')}
        </p>
        <p className={styles.description}>
          {t('coordonnate.loi.success.description')}
        </p>
        <Button
          className={styles.button}
          label={t('button.next')}
          onButtonClick={getDashboard}
          dataCy="confirmation-popup-success-button"
        />
      </section>
    </div>
  );
}
